<!-- Invalid handler for event “click“: got undefined  @click="formData.xxx" 是 formData.xxx 报的错-->
<!-- 我的订单 -->
<template>
  <div class="my-enquiry">
    <eProcess :process-data="processData" :is-active="1"></eProcess>
    <div class="line"></div>
    <!--程序报错，暂时注释掉-->
    <el-form ref="formDom" :rules="formDataRules" :model="formData" class="form-content" size="small">
      <el-row>
        <el-col :span="12">
          <el-form-item label-width="140px" label="应急需求单名称：" prop="enquiryName">
            <el-input
              v-model.trim="formData.enquiryName"
              maxlength="100"
              show-word-limit
              class="edit-input"
              size="small"
              placeholder="请输入应急需求单名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 询价商品清单 -->
      <div class="container">
        <div class="commodity-list">
          <div class="title">需求商品清单</div>
          <div class="commodity-content">
            <div class="handle-btn">
              <eui-btn v-if="!ifIntegrated" type="secondary">
                <span @click="addEnquiryProduct">
                  <i class="el-icon-plus"></i>
                  添加商品
                </span>
              </eui-btn>
              <eui-btn v-if="!ifIntegrated" type="secondary" @click="openBatchProductDia">选择平台商品</eui-btn>
              <eui-btn v-if="!ifIntegrated" type="secondary" @click="openBatchImportDia">批量导入商品</eui-btn>
            </div>
            <!-- table -->
            <div class="table-content">
              <el-table
                :data="formData.tableData"
                border
                max-height="455"
                style="width: 100%, overflow: auto"
                :header-cell-style="{ background: '#F5F5F5' }"
                :header-cell-class-name="must"
                size="small"
                current-row-key="index"
                class="validate-table"
              >
                <el-table-column label="序号" width="60px">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" min-width="280">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tableData.' + scope.$index + '.productName'"
                      :rules="formDataRules.productName"
                    >
                      <el-input
                        v-model.trim="scope.row.productName"
                        :disabled="ifIntegrated"
                        maxlength="100"
                        show-word-limit
                        class="edit-input"
                        size="small"
                        placeholder="商品名称"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="需求数量" min-width="180">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tableData.' + scope.$index + '.requiredQuantity'"
                      :rules="formDataRules.requiredQuantity"
                    >
                      <el-input
                        v-model.trim="scope.row.requiredQuantity"
                        :disabled="isPurchase"
                        maxlength="10"
                        class="edit-input"
                        size="small"
                        placeholder="需求数量"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="计量单位" min-width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData.' + scope.$index + '.unitName'" :rules="formDataRules.unitName">
                      <el-input
                        v-model.trim="scope.row.unitName"
                        :disabled="ifIntegrated"
                        class="edit-input"
                        size="small"
                        maxlength="10"
                        placeholder="计量单位"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="规格型号" min-width="200">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tableData.' + scope.$index + '.specifications'"
                      :rules="formDataRules.specifications"
                    >
                      <el-input
                        v-model.trim="scope.row.specifications"
                        maxlength="100"
                        show-word-limit
                        class="edit-input"
                        size="small"
                        placeholder="规格型号"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="品牌" min-width="180">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData.' + scope.$index + '.brandName'" :rules="formDataRules.brandName">
                      <el-input
                        v-model.trim="scope.row.brandName"
                        class="edit-input"
                        size="small"
                        maxlength="25"
                        placeholder="品牌"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="商品描述" min-width="220">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tableData.' + scope.$index + '.productDescription'"
                      :rules="formDataRules.productDescription"
                    >
                      <el-input
                        v-model.trim="scope.row.productDescription"
                        maxlength="200"
                        show-word-limit
                        class="edit-input"
                        size="small"
                        placeholder="商品描述"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="商品目录" min-width="180">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tableData.' + scope.$index + '.categoryName'"
                      :rules="formDataRules.categoryName"
                    >
                      <el-input
                        v-model.trim="scope.row.categoryName"
                        class="edit-input"
                        size="small"
                        placeholder="商品目录"
                        :readonly="true"
                        @click.native="openCategoryDia(scope.$index)"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150px" fixed="right">
                  <template slot-scope="scope">
                    <eui-btn type="link" @click="uploadDesc(scope.$index, scope.row)">
                      {{
                        scope.row.enquiryDetailAttachmentList.length &&
                        scope.row.enquiryDetailAttachmentList[0].attachmentName
                          ? '已上传描述'
                          : '上传需求描述'
                      }}
                    </eui-btn>
                    <eui-btn
                      v-if="!ifIntegrated"
                      type="link"
                      color="#f0250f"
                      @click="handleDetEnquiryProduct(scope.$index, scope.row)"
                    >
                      删除
                    </eui-btn>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <!-- 询价类型 -->
      <div class="container">
        <div class="commodity-list">
          <div class="title">询价类型</div>
          <div class="commodity-content">
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="100px" label="询价类型：" prop="enquiryType" class="sp-radio">
                  <el-radio-group v-model="formData.enquiryType" @change="enquiryTypeChange">
                    <el-radio :label="1">公开询价</el-radio>
                    <el-tooltip class="left-icon" effect="dark" content="Right Center 提示文字" placement="top">
                      <div slot="content">
                        <p>公开询价信息将在平台公开，所有供应商可参与报价。</p>
                      </div>
                      <div class="icon">?</div>
                    </el-tooltip>
                    <el-radio :label="0">定向询价</el-radio>
                    <el-tooltip class="right-icon" effect="dark" content="Right Center 提示文字" placement="top">
                      <div slot="content">
                        <p>定向询价是向您意向的供应商发起询价，只有被您选中的供应商才可以参与报价。</p>
                      </div>
                      <div class="icon">?</div>
                    </el-tooltip>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 供应商信息 -->
      <div v-if="formData.enquiryType === 0" class="container">
        <div class="commodity-list" style="margin-top: 10px">
          <div class="title">供应商信息</div>
          <div class="commodity-content">
            <el-button size="small" style="margin-top: 10px">
              <span @click="openSupplierDia">
                <i class="el-icon-plus"></i>
                添加供应商
              </span>
            </el-button>
            <div class="table-content">
              <el-table
                max-height="252"
                :data="enquirySupplierAddAOList"
                style="width: 100%; margin-top: 10px"
                border
                size="small"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column prop="date" label="序号" width="60px">
                  <template #default="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="supplierCompany"
                  label="供应商名称"
                  min-width="180"
                  align="center"
                ></el-table-column>
                <el-table-column prop="address" label="操作" width="60px" align="center">
                  <template #default="soltScope">
                    <eui-btn type="link" color="#f0250f" @click="delCompany(soltScope.row)">删除</eui-btn>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <!-- 基本信息 -->
      <div class="container">
        <div class="commodity-list">
          <div class="title">基本信息</div>
          <div class="enquiry-form">
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="142px" label="运费：" prop="includeFreight">
                  <el-radio-group v-model="formData.includeFreight">
                    <el-radio :label="0">包含在商品中</el-radio>
                    <el-radio :label="1">单独明细提报</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="142px" label="结算方式：" prop="isDoC">
                  <el-select v-model="formData.isDoC" placeholder="请选择结算方式">
                    <el-option
                      v-for="item in payTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="142px" label="配送方式：" prop="shipmentType">
                  <el-select v-model="formData.shipmentType" placeholder="请选择配送方式">
                    <el-option
                      v-for="item in shipmentTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <div>
                <el-form-item label-width="142px" label="询价周期选择：" prop="inquiryCycleType">
                  <el-radio-group v-model="formData.inquiryCycleType" @change="inquiryCycleTypeChange">
                    <el-radio :label="0">按照日期</el-radio>
                    <el-radio :label="1">按照天数</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div v-if="formData.inquiryCycleType === 0">
                <!-- :picker-options="pickerReleaseTimeDate" -->
                <el-col :span="12">
                  <el-form-item label-width="142px" label="报价开始时间：" prop="releaseTime">
                    <el-date-picker
                      v-model="formData.releaseTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      format="yyyy-MM-dd HH"
                      value-format="timestamp"
                      default-time="09:00:00"
                      popper-class="noneMinute"
                      @change="releaseTimeChange"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="142px" label="报价截止时间：" prop="quotationDeadline">
                    <el-date-picker
                      v-model="formData.quotationDeadline"
                      :disabled="!formData.releaseTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      format="yyyy-MM-dd HH"
                      value-format="timestamp"
                      default-time="16:00:00"
                      :picker-options="pickerQuotationDeadlineDate"
                      popper-class="noneMinute"
                      @change="quotationDeadlineChange"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </div>
              <div v-if="formData.inquiryCycleType === 1">
                <el-col :span="12">
                  <el-form-item label-width="142px" label="询价周期：" prop="days" style="position: relative">
                    <el-select v-model="formData.days" placeholder="请选择">
                      <el-option v-for="item in 30" :key="item" :label="`${item}天`" :value="item">
                        <span>{{ item }}天</span>
                      </el-option>
                    </el-select>
                    <el-tooltip
                      class="right-icon"
                      style="left: calc(80% + 20px); top: 6px"
                      effect="dark"
                      placement="top"
                    >
                      <div slot="content">
                        <p>询比价开始时间为平台审核通过的时间</p>
                      </div>
                      <div class="icon">?</div>
                    </el-tooltip>
                  </el-form-item>
                </el-col>
              </div>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="142px" label="期望到货日期：" prop="arrivalTime">
                  <el-date-picker
                    v-model="formData.arrivalTime"
                    :disabled="disabledArrivalTime"
                    type="date"
                    placeholder="选择日期时间"
                    value-format="yyyy-MM-dd"
                    :picker-options="arrivalTimeOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="142px" label="邮箱：" prop="email">
                  <el-input v-model="formData.email" auto-complete="on" name="enquiryEmail"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="142px" label="联系人：" prop="realName">
                  <el-input
                    v-model="formData.realName"
                    maxlength="10"
                    auto-complete="on"
                    name="enquiryRealName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="142px" label="联系方式：" prop="mobile">
                  <el-input v-model="formData.mobile" auto-complete="on" name="enquiryMobile"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="142px" label="收货地址：" prop="address">
                  <el-input v-model="formData.address" :readonly="true"></el-input>
                  <eui-btn type="text" style="margin-left: 10px" @click="changeAddress">变更收货地址</eui-btn>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="142px" label="备注：" aria-placeholder="请输入备注信息">
                  <el-input
                    v-model="formData.enquiryRemark"
                    maxlength="300"
                    show-word-limit
                    style="width: 80%"
                    type="textarea"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="142px" label="附件：" type="textarea">
                  <file-upload
                    :url="enquiryAttachmentUrlShow"
                    :limit="5"
                    :file-size="30"
                    :upload-url="uploadUrl"
                    :verify="true"
                    :tips-message="tipsMessage"
                    :upload-image="true"
                    @getFileInfo="getFileInfo"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="142px" label="是否公示：" prop="whetherPublic">
                  <el-radio-group v-model="formData.whetherPublic" :disabled="formData.enquiryType === 0">
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                    <el-tooltip class="right-icon" style="left: 124px" effect="dark" placement="top">
                      <div slot="content">
                        <p>是否把询价结果公示在平台上</p>
                      </div>
                      <div class="icon">?</div>
                    </el-tooltip>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-form>

    <!-- 审批流程设置 -->
    <div class="container">
      <div class="commodity-list">
        <div class="title">审批流程设置</div>
        <div
          class="enquiry-form"
          style="display: flex; flex-direction: row; justify-content: space-between; padding: 20px; align-items: center"
        >
          <div class="left">
            <div :class="{ 'margin-l8': !ifSwitch }">
              <div v-if="authFlag && !ifSwitch" class="no-info">
                <div class="choose-audit">
                  <div class="choose-audit-tip">
                    <img src="@/assets/img/approval/gray-mark.png" alt="" />
                    <span class="gray-color">贵企业未启用审批流程，无需选择此项。</span>
                  </div>
                  <div v-if="authFlag" class="choose-btn" @click="toSetApprove">配置审批流</div>
                </div>
              </div>
              <div v-else-if="!authFlag && ifSwitch && approvalList.length === 0" class="no-info">
                <div class="choose-audit">
                  <div class="choose-audit-tip">
                    <img src="../../../../../assets/img/approval/exclamation-mark.png" alt="" />
                    <span>贵企业尚未配置审批流，请联系管理员进行配置。</span>
                  </div>
                </div>
              </div>
              <div v-else-if="ifSwitch" class="no-info">
                <div v-if="approvalItem.auditName">
                  {{ approvalItem.auditName }}
                </div>
                <div v-else class="choose-audit">
                  <div class="choose-audit-tip">
                    <img src="../../../../../assets/img/approval/exclamation-mark.png" alt="" />
                    请选择审批流程
                  </div>
                </div>
                <div class="choose-btn" @click="choiceAudit">选择审批流程</div>
              </div>
              <div v-else class="no-info">
                <div style="display: flex; align-items: center">
                  <img src="@/assets/img/approval/gray-mark.png" alt="" />
                  <span class="gray-color">贵企业未启用审批流程，无需选择此项。</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="warning-content">
      <span>询价单待平台审核通过后，供应商方可报价，请耐心等待。</span>
    </div>
    <div class="handle-button">
      <!-- [vue/no-parsing-error] -->
      <eui-btn type="secondary" @click="goBack">&lt; 返回</eui-btn>
      <div class="right-btn">
        <eui-btn @click="submitSaveForm(false)">保存</eui-btn>
        <eui-btn @click="submitSaveForm(true)">发布询价</eui-btn>
      </div>
    </div>

    <!-- 选择类目弹窗 -->
    <category-dia :category-visible.sync="categoryVisible" @getCategoryInfo="getCategoryInfo" />
    <!-- 批量导入 -->
    <batch-import :batch-import-visible.sync="batchImportVisible" @getbatchImportList="getbatchImportList" />
    <!-- 批量选择询价商品信息 弹窗 -->
    <select-enquiry-products
      :select-products-visible.sync="selectProductsVisible"
      :select-products-list="selectProductsList"
      @getSelectProducts="getSelectProducts"
    />

    <!-- 上传商品描述附件 -->
    <product-desc-dia
      :product-desc-visible.sync="productDescVisible"
      :show-file-list="showFileList"
      @getProductDescFile="getProductDescFile"
    />

    <!-- 基本信息-选择供应商弹窗 -->
    <add-supplier-dia
      :add-supplier-visible.sync="addSupplierVisible"
      :company-table-list="companyTableList"
      @getSelectCompany="getSelectCompany"
    />

    <!-- 地址弹窗 -->
    <address-dia ref="addressDia" :show-mask.sync="showMask" @setAddress="getAddress"></address-dia>

    <!-- 选择审批流弹窗 -->
    <approve :show-audit-mask.sync="showAuditMask" :approval-list="approvalList" @getApprovalChain="getApprovalChain" />

    <e-dialog
      dialog-title="提示"
      :dialog-type="''"
      :center-dialog-visible="blackVisible"
      :popup-width="'450px'"
      @updateVisible="handleBlackClose"
      @resetPopupData="handleBlackClose"
      @submitPopupData="handleBlackClose"
    >
      <div>{{ tipContent }}</div>
    </e-dialog>
  </div>
</template>
<script>
import EProcess from '@/modules/projectA/components/common/e-process.vue';
import Api from '@/modules/projectA/api/enquiry/index';
import orderApi from '@/modules/projectA/api/order';
import userApi from '@/modules/projectA/api/user';
import filingApi from '@/modules/projectA/api/filing';
import SelectEnquiryProducts from './selectEnquiryProductsCopy.vue';
import BatchImport from './batchImport.vue';
import ProductDescDia from './productDescDia.vue';
import CategoryDia from './categoryDia.vue';
import AddSupplierDia from './addSupplierDia.vue';
import AddressDia from './addressDia.vue';
import FileUpload from './fileUpload.vue';
import approveMixin from './mixins/approveMixin.js';
import eDialog from '../../../components/common/e-dialog.vue';

export default {
  components: {
    SelectEnquiryProducts,
    BatchImport,
    ProductDescDia,
    CategoryDia,
    AddSupplierDia,
    AddressDia,
    EProcess,
    FileUpload,
    eDialog,
  },
  mixins: [approveMixin],
  data() {
    const enquiryTypeObj = {
      0: '定向询价',
      1: '公开询价',
    };

    function checkPhone(tel) {
      const mobile = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      const phone = /^(0|4)\d{2,3}-?\d{7,8}$/;
      return mobile.test(tel) || phone.test(tel);
    }
    function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入电话号码'));
      }

      if (!checkPhone(value)) {
        callback(new Error('请输入正确的电话号码'));
      } else {
        callback();
      }
    }

    function checkEnquiryName(enquiryName) {
      const res = /^[a-zA-Z0-9\u4e00-\u9fa5]|[-_()[]{}，。《》<>]+$/; // 中文 字母 数字
      // /^[a-zA-Z]{1}([a-zA-Z0-9]|[._]){4,19}$/;
      return res.test(enquiryName);
    }

    function validateEnquiryName(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入询价单名称'));
      }

      if (!checkEnquiryName(value)) {
        callback(new Error('请输入正确的询价单名称'));
      } else {
        callback();
      }
    }

    // 验证需求数量
    function checkNumber(requiredQuantity) {
      // const numberReg = /^[0-9]*[1-9][0-9]*$/;
      const numberReg = /^-?\d+(\.\d{1,3})?$/;
      return numberReg.test(requiredQuantity);
    }
    function validateRequiredQuantity(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入需求数量'));
      }
      if (value <= 0) {
        return callback(new Error('需求数量需大于0'));
      }
      if (!checkNumber(value)) {
        callback(new Error('只能输入最多3位小数的数字'));
      } else {
        callback();
      }
    }

    // 验证邮箱
    function checkEmail(email) {
      const emailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      return emailReg.test(email);
    }
    function validateEmail(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入邮箱'));
      }

      if (!checkEmail(value)) {
        callback(new Error('请输入正确的邮箱'));
      } else {
        callback();
      }
    }
    return {
      tipContent: '',
      blackVisible: false,
      confirmFlag: false, // 是否确认协议
      // 是否是一体化询比价
      ifIntegrated: false,
      tipsMessage: '最多可上传5个附件，每个附件大小不超过30M。',
      uploadUrl: '',
      selectProductsList: [],
      // 回显供应商
      companyTableList: [],
      // 回显文件
      showFileList: [],
      processData: [
        {
          itemName: '发布询价需求',
          title: '发布询价需求',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '供应企业报价',
          title: '供应企业报价',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '选商定价',
          title: '选商定价',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '结果公示',
          title: '结果公示',
          tip: '',
          description: '',
          icon: '',
        },
      ],
      enquiryTypeObj,
      // 类目
      categoryVisible: false,
      categoryInfo: {},
      // 头信息
      productDetail: {},
      limit: 1,
      fileSize: 30,
      categoryIndex: 0,
      // 上传需求描述的index
      clickTableIndex: 0,
      // 列表验证+列表数据
      formData: {
        includeFreight: 0,
        enquiryType: 1,
        address: '',
        enquiryName: '',
        tableData: [],
        enquiryAttachmentAOList: [],
        enquiryAttachmentCount: 0,
        arrivalTime: '',
        releaseTime: '',
        quotationDeadline: '',
        isDoC: null,
        shipmentType: null,
        inquiryCycleType: 0,
        days: 3,
        whetherPublic: -1,
      },
      formDataRules: {
        productName: {
          type: 'string',
          required: true,
          message: '请输入商品名称',
          trigger: 'blur',
        },
        requiredQuantity: {
          required: true,
          validator: this.validateRequiredQuantity,
          trigger: 'blur',
        },
        unitName: {
          type: 'string',
          required: true,
          message: '请输入计量单位',
          trigger: 'blur',
        },
        days: [{ required: true, message: '请选择时间周期', trigger: 'change' }],
        enquiryType: [{ required: true, message: '请选择询价类型', trigger: 'change' }],
        enquiryName: [{ required: true, validator: validateEnquiryName, trigger: 'change' }],
        realName: [{ required: true, message: '请输入联系人', trigger: 'change' }],
        // mobile: [
        //   { required: true, message: '请输入联系电话', trigger: 'change' },
        // ],
        quotationDeadline: [
          { required: true, message: '请选择报价截止日期', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (this.formData.releaseTime >= value) {
                callback(new Error('报价截止时间不得小于报价开始时间'));
              } else if (new Date().getTime() >= value) {
                callback(new Error('报价截止时间不得小于当前时间'));
              } else {
                callback();
              }
            },
            message: '',
            trigger: 'change',
          },
        ],
        releaseTime: [{ required: true, message: '请选择报价开始日期', trigger: 'change' }],
        arrivalTime: [{ required: true, message: '请选择期望到货日期', trigger: 'change' }],
        includeTax: [{ required: true, message: '请选择运费', trigger: 'change' }],
        address: [{ required: true, message: '请选择地址', trigger: 'change' }],
        mobile: [
          {
            required: true,
            validator: validatePhone,
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur',
          },
        ],
        isDoC: [{ required: true, message: '请选择结算方式', trigger: 'change' }],
        shipmentType: [{ required: true, message: '请选择配送方式', trigger: 'change' }],
      },

      // 选择商品-弹窗
      selectProductsVisible: false,
      // 批量导入-弹窗
      batchImportVisible: false,
      // 上传需求描述-弹窗
      productDescVisible: false,
      enquiryTypeFlag: false,
      addSupplierVisible: false,
      // 定向询价供应商列表
      enquirySupplierAddAOList: [],
      addressVisible: false,
      /* endTime: "",
      beginTime: "",
      pickerBeginDate: {
        disabledDate: time => {
          let endTime = this.endTime;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      // /限制不能选之前的时间
      pickerEndDate: {
        disabledDate: time => {
          let beginTime = this.beginTime;
          console.log(beginTime, "beginTimebeginTime");
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime();
          }
        }
      }, */
      //
      // 报价开始时间
      pickerReleaseTimeDate: {
        disabledDate: (time) => {
          const endTime = this.formData.quotationDeadline;
          console.log(endTime, 'pickerReleaseTimeDate');
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime() - 8.64e7 || time.getTime() <= Date.now() - 8.64e7;
          }
          return time.getTime() <= Date.now() - 8.64e7;
        },
      },
      // 报价结束时间 /限制不能选之前的时间
      pickerQuotationDeadlineDate: {
        disabledDate: (time) => {
          const beginTime = this.formData.releaseTime;
          if (beginTime) {
            return (
              time.getTime() < new Date(beginTime).getTime() - 8.64e7 ||
              time.getTime() > new Date(beginTime).getTime() + 29 * (24 * 60 * 60 * 1000)
            );
          }
        },
      },
      // 期望到货日期
      arrivalTimeOptions: {
        /* disabledDate: (time) => {
          // 如果没有后面的-8.64e7就是不可以选择今天的
          // return time.getTime() < Date.now();
          const endTime = this.formData.quotationDeadline;
          if (endTime) {
            return time.getTime() < new Date(endTime).getTime() + 8.64e7;
          }
        }, */
        disabledDate: (time) => {
          // 如果没有后面的-8.64e7就是不可以选择今天的
          // return time.getTime() < Date.now();
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      // 报价结束时间 /限制不能选之前的时间
      /* pickerQuotationDeadlineDate: {
        disabledDate: time => {
          let beginTime = this.formData.releaseTimeStart;
          console.log(beginTime, "pickerQuotationDeadlineDate");
          if (beginTime) {
            return (
              time.getTime() <
                new Date(beginTime).getTime() + 3 * (24 * 60 * 60 * 1000) ||
              time.getTime() >
                new Date(beginTime).getTime() + 14 * (24 * 60 * 60 * 1000)
            );
          }
        }
      } */
      enquiryAttachmentUrlShow: [],
      isPurchase: false,

      showMask: false,
      payTypeOptions: [
        { label: '款到发货', value: 0 },
        { label: '货到付款', value: 1 },
      ],
      shipmentTypeOptions: [
        { label: '卖家自行配送', value: 1 },
        { label: '第三方物流', value: 3 },
      ],
    };
  },
  computed: {
    disabledArrivalTime() {
      if (this.formData.inquiryCycleType === 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.arrivalTimeOptions = {
          disabledDate: (time) => {
            // 如果没有后面的-8.64e7就是不可以选择今天的
            // return time.getTime() < Date.now();
            const endTime = this.formData.quotationDeadline;
            if (endTime) {
              return time.getTime() < new Date(endTime).getTime() + 8.64e7;
            }
          },
        };
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.arrivalTimeOptions = {
          disabledDate: (time) => {
            // 如果没有后面的-8.64e7就是不可以选择今天的
            // return time.getTime() < Date.now();
            return time.getTime() < Date.now() - 8.64e7;
          },
        };
      }
      if (this.formData.inquiryCycleType === 1) {
        return false;
      }
      return !this.formData.quotationDeadline;
    },
  },
  watch: {
    'formData.enquiryType': function (val) {
      this.formData.whetherPublic = val === 0 ? 1 : 0;
    },
  },
  created() {
    // getAddressList()
  },
  mounted() {
    const { enquiryId, createMode = '0' } = this.$route.query;
    const purchases = ['3', '4'];
    this.isPurchase = purchases.includes(createMode);

    const integrateds = ['2', '3', '4'];
    this.ifIntegrated = integrateds.includes(createMode);

    this.getDetailInfo({ enquiryId: Number(enquiryId) });
    this.uploadUrl = Api.enquiryFileUrl();
    console.log(this.uploadUrl, 'this.uploadUrl');
  },
  methods: {
    inquiryCycleTypeChange(value) {
      if (value === 0) {
        this.formData.arrivalTime = '';
      }

      if (value === 0) {
        this.arrivalTimeOptions = {
          disabledDate: (time) => {
            // 如果没有后面的-8.64e7就是不可以选择今天的
            // return time.getTime() < Date.now();
            const endTime = this.formData.quotationDeadline;
            if (endTime) {
              return time.getTime() < new Date(endTime).getTime() + 8.64e7;
            }
          },
        };
      } else {
        this.arrivalTimeOptions = {
          disabledDate: (time) => {
            // 如果没有后面的-8.64e7就是不可以选择今天的
            // return time.getTime() < Date.now();
            return time.getTime() < Date.now() - 8.64e7;
          },
        };
      }
    },
    handleBlackClose() {
      this.blackVisible = false;
    },
    // 开始时间改变
    releaseTimeChange(val) {
      console.log(val, '开始时间改变了');
      // 为null
      if (!val) {
        this.formData.quotationDeadline = '';
        this.formData.arrivalTime = '';
      }
    },
    // 报价截止时间
    quotationDeadlineChange(val) {
      // console.log(val);
      // const time = `${this.getNowFormatDate()} 16:00:00`;
      // const newDate = new Date(time).getTime();
      // /* // 为null
      // if (!val) {
      //   this.formData.arrivalTime = "";
      // } */
      // this.formData.arrivalTime = '';
      // if (newDate === val) {
      //   this.formData.quotationDeadline = '';
      // }
    },
    getNowFormatDate() {
      const date = new Date();
      const seperator1 = '-';
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = `0${strDate}`;
      }
      const currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    checkNumber(requiredQuantity) {
      // const numberReg = /^[0-9]*[1-9][0-9]*$/;
      const numberReg = /^-?\d+(\.\d{1,3})?$/;
      return numberReg.test(requiredQuantity);
    },
    validateRequiredQuantity(rule, value, callback) {
      console.log(rule, this.ifIntegrated, 'rulerule');
      let remainingQuantity = 0;
      if (this.ifIntegrated && !this.isPurchase) {
        const ruleArr = rule.field.split('.');
        const index = ruleArr[1];
        const item = this.formData.tableData[index];
        remainingQuantity = item.remainingQuantity ? item.remainingQuantity : item.intqty;
        console.log(remainingQuantity, 'remainingQuantity');
      }

      if (!value) {
        return callback(new Error('请输入需求数量'));
      }
      if (value <= 0) {
        return callback(new Error(`需求数量需大于0`));
      }
      if (this.ifIntegrated && !this.isPurchase) {
        if (value > remainingQuantity) {
          return callback(new Error(`需求数量需最多${remainingQuantity}`));
        }
      }
      if (!this.checkNumber(value)) {
        callback(new Error('只能输入最多3位小数的数字'));
      } else {
        callback();
      }
    },
    // 得到备注下面附件
    getFileInfo(fileList) {
      console.log('附件：', fileList);
      this.formData.enquiryAttachmentCount = fileList.length;
      this.formData.enquiryAttachmentList = fileList.map((item) => ({
        attachmentUrl: item.fileUrl,
        attachmentName: item.fileName,
        isSupplierVisible: item.isSupplierVisible,
      }));
    },
    goBack(times) {
      if (times) {
        this.$router.push({
          path: '/emergencyEnquiry/enquiryManage',
          query: { t: times },
        });
      } else {
        this.$router.push({
          path: '/emergencyEnquiry/enquiryManage',
        });
      }
    },
    // 采购商-查询询价单详情
    async getDetailInfo(params) {
      this.detailLoading = true;
      await Api.queryEnquiryDetailByEnquiryId(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          const { data = {} } = res;
          this.formData = { ...this.formData, ...data };
          this.approvalItem.auditName = this.formData.auditName || '';
          if (this.formData.auditId) {
            this.approvalItem.auditId = this.formData.auditId;
            this.getItemPid(this.formData.auditId);
          }
          // 过期/作废的重新询价把时间给干掉
          if (data.enquiryStatus === 8 || data.enquiryStatus === 10) {
            this.formData.quotationDeadline = '';
            this.formData.releaseTime = '';
            this.formData.arrivalTime = '';
            // quotationDeadline 报价截止日期
            // releaseTime 报价开始日期
            // arrivalTime 期望到货日期
          } else {
            this.formData.quotationDeadline = new Date(data.quotationDeadline).getTime();

            if (data.releaseTime) {
              this.formData.releaseTime = new Date(data.releaseTime).getTime();
            }
          }

          if (data.enquirySupplierList && data.enquirySupplierList.length !== 0) {
            this.enquirySupplierAddAOList = [...data.enquirySupplierList];

            const newData = [...data.enquirySupplierList];

            // 处理成接口需要的数据
            newData.forEach((item) => {
              item.companyName = item.supplierCompany;
              item.companyId = item.supplierCompanyId;
            });
            this.companyTableList = [...newData];
            console.log(this.companyTableList, 'this.companyTableListthis.companyTableList');
          }
          // enquiryDetailId
          data.enquiryDetailList.forEach((item, index) => {
            item.mySkuId = item.enquiryDetailId || new Date().getTime() + index;
            item.skuid = item.productId;
          });
          console.log(data.enquiryDetailList, '商品数据');
          this.enquiryDetailList = [...data.enquiryDetailList];

          if (this.ifIntegrated && !this.isPurchase) {
            data.enquiryDetailList.forEach((item) => {
              this.$set(item, 'remainingQuantity', item.purchaseRequestVO.remainingQuantity);
              this.$set(item, 'intqty', item.purchaseRequestVO.intqty);
            });
          }
          this.formData.tableData = [...data.enquiryDetailList];
          this.formData.tableData.forEach((item) => {
            if (!item.enquiryDetailAttachmentList[0].attachmentUrl) {
              // 数据一定的是响应的
              this.$set(item, 'enquiryDetailAttachmentList', [
                {
                  attachmentName: null,
                  attachmentUrl: null,
                  enquiryDetailAttachmentId: item.enquiryDetailAttachmentList[0].enquiryDetailAttachmentId,
                },
              ]);
            }
          });

          console.log(this.formData.tableData, '列表数据');
          // 回显
          this.selectProductsList = [...data.enquiryDetailList];
          console.log(typeof data.enquiryAttachmentUrl, 'data.enquiryAttachmentUrl');
          // 展示转换
          if (data.enquiryAttachmentList?.length) {
            const enquiryAttachmentUrlShow = data.enquiryAttachmentList;
            this.enquiryAttachmentUrlShow = enquiryAttachmentUrlShow.map((item) => ({
              fileUrl: item.attachmentUrl,
              fileName: item.attachmentName,
              isSupplierVisible: item.isSupplierVisible,
            }));
          }
          // this.formData.enquiryAttachmentUrl = enquiryAttachmentUrl.map(() => ({}))
        }
      });
    },
    delCompany(row) {
      const { companyId } = row;
      this.enquirySupplierAddAOList.some((item, i) => {
        if (item.companyId === companyId) {
          this.enquirySupplierAddAOList.splice(i, 1);
        }
      });
      this.companyTableList = [...this.enquirySupplierAddAOList];
    },
    getAddress(addressObj) {
      this.showMask = false;
      console.log(addressObj);
      const { detailAddress, addressId, provinceName, provinceId, cityId, cityName, regionName, regionId } = addressObj;
      this.formData.address = detailAddress;
      this.formData.addressId = addressId;
      this.formData.country = '中国';
      this.formData.countryId = 111;
      this.formData.province = provinceName;
      this.formData.provinceId = provinceId;
      this.formData.cityId = cityId;
      this.formData.city = cityName;
      this.formData.region = regionName;
      this.formData.regionId = regionId;
      console.log(this.formData.address, 'this.formData.detailAddress');
    },

    // 修改地址
    changeAddress() {
      this.showMask = true;
      console.log(this.showMask, 'this.showMask');
    },

    /* // 修改地址 一直点不开的原因在这里
    changeAddress() {
      // this.$refs.addressDia.choiceAddress();
      this.$refs.addressDia.getAddressList();
    }, */
    // 报价截止日期
    startClassChange(courseDay) {
      this.formData.quotationDeadline = courseDay || '';

      if (courseDay) {
        courseDay && this.endClassChange(courseDay + 13 * 24 * 3600 * 1000);
      }
    },
    // 期望到货日期
    endClassChange(endCourseDay) {
      this.formData.arrivalTime = endCourseDay || '';
    },

    ///
    // 得到供应商列表
    getSelectCompany(val) {
      if (val.length > 100) {
        this.$message.warning('定向询价最多添加100个供应商。');
        return;
      }
      this.companyTableList = [...val];
      console.log(this.companyTableList, 'this.companyTableListthis.companyTableList');
      /*
        supplierCompany	string
        供应商名称

        supplierCompanyId	integer($int64)
        供应商ID
      */
      // 处理成接口需要的数据
      val.forEach((item) => {
        item.supplierCompany = item.companyName;
        item.supplierCompanyId = item.companyId;
      });
      this.enquirySupplierAddAOList = [...val];
    },
    // 基本信息选供应商
    openSupplierDia() {
      this.addSupplierVisible = true;
    },
    // 询价类型改变,定向询价选供应商
    enquiryTypeChange(val) {
      console.log(val);
      this.enquiryTypeFlag = val === 0;
      this.formData.whetherPublic = val === 0 ? 1 : 0;
    },
    // 展示商品类目弹窗
    openCategoryDia(index) {
      console.log(111111);
      this.categoryVisible = true;
      this.categoryIndex = index;
    },
    // 得到所选类目的信息
    getCategoryInfo(val) {
      /* this.categoryInfo.categoryCode = val.categoryCode;
      this.categoryInfo.categoryName = val.categoryName;
      console.log(val); */
      this.$set(this.formData.tableData[this.categoryIndex], 'categoryCode', val.categoryCode);
      this.$set(this.formData.tableData[this.categoryIndex], 'categoryName', val.categoryName);
    },
    // 展示批量导入弹窗
    openBatchImportDia() {
      this.batchImportVisible = true;
    },
    // 批量导入弹窗取消
    canceBatchImportlHandle() {
      this.$refs.uploadFile.clearFiles();
    },
    // 得到批量导入后的数据
    getbatchImportList(val) {
      const valLength = val.length;
      const tableLength = this.formData.tableData.length;
      const allLength = valLength + tableLength;
      console.log(`数组长度:${allLength}`);
      if (allLength > 1000) {
        this.$message.warning('询价清单最多添加1000个商品。');
        return;
      }
      this.formData.tableData = [...val, ...this.formData.tableData];
      this.formData.tableData.forEach((item) => {
        if (!item.enquiryDetailAttachmentList) {
          item.enquiryDetailAttachmentList = [{ attachmentName: '', attachmentUrl: '' }];
        }
      });
      this.selectProductsList = [...this.formData.tableData];
    },
    // 数组去重
    deArr(arr) {
      const obj = {};
      const newArr = arr.reduce(function (item, next) {
        obj[next.mySkuId] ? '' : (obj[next.mySkuId] = true && item.push(next));
        return item;
      }, []);
      return newArr;
    },
    // 得到选择后的询价商品信息
    getSelectProducts(val) {
      console.log(val, '商品信息');
      console.log(this.formData.tableData, '这里的问题么');
      //
      /* val.forEach(item => {
        this.$set(item, "unitName", item.unitvalue);
        // item.unitName = item.unitvalue;
        this.$set(item, "brandName", item.brandname);
        // item.brandName = item.brandname;
        this.$set(item, "categoryName", item.category);
        // item.categoryName = item.category;
        this.$set(item, "categoryCode", item.categoryid);
        // item.categoryCode = item.categoryid;
        this.$set(item, "productName", item.skuname);
        // item.productName = item.skuname;
        this.$set(item, "specifications", item.specificationstr);
        this.$set(item, "mySkuId", item.skuid);
        this.$set(item, "enable", true);
        // item.specifications = item.specificationstr;
      }); */
      const newArr = [...this.formData.tableData, ...val];
      if (this.selectProductsList.length > val.length) {
        // 那么肯定是删除了
      }

      const getArr = this.deArr(newArr);
      console.log(newArr, 'newArr');
      console.log(getArr, 'getArr');

      /* const valLength = val.length;
      const tableLength = this.formData.tableData.length;
      const allLength = valLength + tableLength; */
      const allLength = getArr.length;
      console.log('数组长度:', allLength);
      if (allLength > 1000) {
        this.$message.warning('询价清单最多添加1000个商品。');
        return;
      }
      this.formData.tableData = [...getArr];

      this.formData.tableData.forEach((item) => {
        if (!item.enquiryDetailAttachmentList) {
          // 数据一定的是响应的
          this.$set(item, 'enquiryDetailAttachmentList', [{ attachmentName: null, attachmentUrl: null }]);
          /*  item.enquiryDetailAttachmentList = [
            { attachmentName: "", attachmentUrl: "" }
          ]; */
        }
      });
      console.log(this.formData.tableData, '列表数据');
      this.selectProductsList = [...this.formData.tableData];
    },
    // 展示批量选择询价商品信息-弹窗
    openBatchProductDia() {
      this.selectProductsVisible = true;
    },

    // 表头加*号
    must(obj) {
      if (obj.columnIndex === 1 || obj.columnIndex === 2 || obj.columnIndex === 3) {
        return 'must';
      }
      return true;
    },
    // 上传需求描述
    uploadDesc(index, row) {
      this.clickTableIndex = index;
      this.productDescVisible = true;
      this.showFileList = [
        {
          name: row.enquiryDetailAttachmentList[0].attachmentName,
          url: row.enquiryDetailAttachmentList[0].attachmentUrl,
        },
      ];
    },
    getProductDescFile(file) {
      console.dir(file, 'flie');
      /* enquiryDetailAttachmentList: [
        { attachmentName: null, attachmentUrl: null }
      ] */

      this.formData.tableData[this.clickTableIndex].enquiryDetailAttachmentList[0].attachmentName = file.fileName;
      this.formData.tableData[this.clickTableIndex].enquiryDetailAttachmentList[0].attachmentUrl = file.url;
    },
    // 添加询价商品 mySkuId
    addEnquiryProduct() {
      const newVlaue = {
        categoryName: '',
        categoryCode: '',
        brandName: '',
        productName: '',
        specifications: '',
        productDescription: '',
        requiredQuantity: '',
        unitName: '',
        mySkuId: new Date().getTime(),
        enquiryDetailAttachmentList: [{ attachmentName: null, attachmentUrl: null }],
      };
      console.log(newVlaue, 'newVlaue');
      if (this.formData.tableData.length > 1000) {
        this.$message.warning('询价清单最多添加1000个商品。');
        return;
      }
      console.log(`数组长度:${this.formData.tableData.length}`);
      this.formData.tableData.push(newVlaue);
      console.log(this.formData.tableData, '询价商品');
      this.selectProductsList = [...this.formData.tableData];
    },
    // 删除-商品
    handleDetEnquiryProduct(index) {
      this.formData.tableData.splice(index, 1);
      this.selectProductsList = [...this.formData.tableData];
    },
    async submitSaveForm(saveFlag) {
      console.log(this.formData);
      this.$refs.formDom.validate((valid) => {
        if (valid) {
          const submitForm = { quotationType: 0 };
          submitForm.includeTax = 1;
          submitForm.saveFlag = saveFlag;
          // enquiryId: 396; 保存不需要false, 提交需要true
          this.formData.auditId = this.approvalItem.auditId || null;
          this.formData.enableWorkflow = this.approvalItem.auditId ? 1 : 0;
          this.formData.saveFlag = saveFlag;
          // 合并基础信息/类目信息
          Object.assign(submitForm, this.formData);

          // 定向询价时 添加供应商信息
          console.log(this.formData.enquiryType, 'this.formData.enquiryType ');
          if (this.formData.enquiryType === 0) {
            // 定向询价公司列表 enquirySupplierAddAOList
            submitForm.enquirySupplierAddAOList = [...this.enquirySupplierAddAOList];
            if (submitForm.enquirySupplierAddAOList.length === 0) {
              this.$message.warning('若询价类型为定向询价必须选择供应商。');
              return;
            }
            if (submitForm.enquirySupplierAddAOList.length > 1000) {
              this.$message.warning('供应商最多添加1000个商品。');
              return;
            }
          } else {
            submitForm.enquirySupplierAddAOList = [];
          }

          // 商品列表清单提交字段 enquiryDetailList
          submitForm.enquiryDetailList = [...this.formData.tableData];
          if (submitForm.enquiryDetailList.length === 0) {
            this.$message.warning('请添加询价清单商品。');
            return;
          }
          if (submitForm.enquiryDetailList.length > 1000) {
            this.$message.warning('询价清单最多添加1000个商品。');
            return;
          }

          submitForm.enquiryAttachmentAOList = this.formData.enquiryAttachmentList || [];

          delete submitForm.tableData;

          if (this.ifSwitch && !this.approvalItem.auditId) {
            this.$message.warning('请选择审批流!');
            return;
          }

          // 平台校验黑名单
          orderApi
            .blacklistCheck({
              businessDirection: 'purchase',
              companyId: this.formData.tableData[0].purchaseCompanyId,
              serviceType: 1,
            })
            .then((resCheck) => {
              if (resCheck.success && resCheck.data.existFlag) {
                this.tipContent = `您已被限制在平台发起询价，如有疑问，请联系平台运营${resCheck.data.contactsMobile}。`;
                // 弹窗提示
                this.blackVisible = true;
                return false;
              }
              this.toAddEnquiry(submitForm, saveFlag);
            });
        }
      });
    },
    async toAddEnquiry(submitForm, saveFlag) {
      // 询价周期
      if (this.formData.inquiryCycleType === 1) {
        delete this.formData.quotationDeadline;
        delete this.formData.releaseTime;
      } else {
        delete this.formData.days;
      }

      // 重新询价-过期/作废
      const api = submitForm.enquiryStatus === 8 || submitForm.enquiryStatus === 10 ? 'restartEnquiry' : 'addEnquiry';
      Api[api](submitForm).then((res) => {
        if (res.code === '200') {
          if (saveFlag) {
            this.$router.replace({
              path: '/emergencyEnquiry/enquirySuccess',
            });
          } else {
            this.$router.replace({
              path: '/emergencyEnquiry/enquirySuccess',
              query: {
                saveFlag: 0,
              },
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
.noneMinute {
  .el-time-spinner__wrapper {
    width: 100% !important;
  }
  .el-scrollbar:nth-of-type(2) {
    display: none;
  }
}
.el-message-box {
  border-radius: 0;
}
.el-button {
  border-radius: 0;
}
</style>
<style lang="scss" scoped>
@import '@/assets/css/mixin/flex.scss';
.date-icon {
  position: relative;
}
.my-enquiry {
  .line {
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
  }
  .search-form {
    display: flex;
    .el-input {
      width: 200px;
    }
  }
  .form-content {
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-date-editor.el-input {
      width: 100%;
      .el-input__inner {
        border-radius: 0;
      }
    }
    ::v-deep .el-input {
      .el-input__inner {
        border-radius: 0;
      }
    }

    .sp-radio {
      margin: 10px 0 0 0;
      ::v-deep .el-radio {
        position: relative;
        margin-right: 60px;
      }
    }

    .left-icon {
      position: absolute;
      left: 96px;
      top: 5px;
      width: 22px;
      height: 22px;
      line-height: 20px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
    .right-icon {
      position: absolute;
      left: 236px;
      top: 5px;
      width: 22px;
      height: 22px;
      line-height: 20px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
  }

  .commodity-list {
    border: 1px solid #d9d9d9;
    margin-bottom: 10px;
    &:last-child {
      margin-top: 10px;
    }

    .title {
      color: #333;
      height: 44px;
      line-height: 44px;
      background: #f5f5f5;
      padding-left: 20px;
      border-bottom: 1px solid #d9d9d9;
      font-size: 16px;
      font-weight: bold;
    }
    .commodity-content {
      padding: 0 10px 10px 10px;
      .set-type {
        line-height: 52px;
        i {
          font-size: 20px;
          cursor: pointer;
          &:hover {
            color: #2587ff;
          }
        }
      }
      .handle-btn {
        margin: 10px 0;
        .el-button {
          border-radius: 0;
        }
      }
      .table-content {
        .validate-table {
          ::v-deep .el-table__row td {
            padding: 8px 0 0 0;
          }
        }
        ::v-deep .el-table--scrollable-x .el-table__body-wrapper {
          overflow-x: auto;
        }
        .del-btn {
          color: #f0250f;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        ::v-deep .el-table th.must div:before {
          content: '*';
          color: #ff1818;
        }
        .edit-input {
          ::v-deep .el-input__inner {
            border-radius: 0;
          }
        }
      }
      .table-handle-btn {
        color: #0064c8;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      .err-btn {
        color: #f0250f;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }

      .add-table-handle-btn {
        margin-top: 10px;
        line-height: 38px;
        text-align: center;
        border: 1px dotted #d9d9d9;
        span {
          cursor: pointer;
        }
      }
    }
    .enquiry-form {
      padding-top: 20px;
      ::v-deep .el-select {
        width: 100%;
      }
      ::v-deep .el-date-editor.el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-textarea {
        width: 80%;
        .el-textarea__inner {
          border-radius: 0;
        }
      }
      .address-btn {
        color: #0064c8;
        text-decoration: underline;
        cursor: pointer;
      }

      .left {
        @include flex(start, center, column);
        width: 100%;
        color: #333;
        font-size: 14px;
        line-height: 31px;
        margin: 5px 20px;

        .both-side {
          display: flex;
          justify-content: space-between;
          .receive-address {
            color: #2587ff;
            cursor: pointer;
            border-bottom: 1px solid transparent;
            &:hover {
              border-bottom: 1px solid #2587ff;
            }
          }
        }
        .margin-l8 {
          margin-left: -18px;
        }
        .break {
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .no-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          .choose-btn {
            width: 120px;
            height: 30px;
            background: #2587ff;
            font-size: 14px;
            line-height: 30px;
            text-align: center;
            color: #ffffff;
            cursor: pointer;
          }
          .choose-audit {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .choose-audit-tip {
              display: flex;
              align-items: center;
            }
            .choose-btn {
              width: 120px;
              height: 30px;
              background: #2587ff;
              font-size: 14px;
              line-height: 30px;
              text-align: center;
              color: #ffffff;
              cursor: pointer;
            }
          }
          /* div {
            display: flex;
            align-items: center;
            position: relative;
          } */

          .gray-color {
            color: #c5c5c5;
          }
          img {
            width: 18px;
            height: 18px;
            margin-right: 10px;
          }
        }
      }
      .right {
        .choose-btn {
          width: 120px;
          height: 30px;
          background: #2587ff;
          font-size: 14px;
          line-height: 30px;
          text-align: center;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }
  .handle-button {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .back-btn {
      color: #333;
      border: 1px solid #dcdfe6;
    }
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }
    .right-btn {
      display: flex;
    }
    .reset-btn {
      background: #e8efff;
      border: 1px solid #2587ff;
      color: #2587ff;
      margin-right: 30px;
      line-height: 27px;
      &:hover,
      :active {
        background-color: #126edf;
        color: #fff;
      }
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
  .pagination {
    margin-top: 18px;
  }
  .warning-content {
    display: flex;
    align-items: center;
    line-height: 56px;
    background: #fffce8;
    padding-left: 10px;
    margin-top: 10px;
    &::before {
      content: '*';
      color: #f0250f;
    }
  }
}
</style>
